 <template>
  <v-form ref="formSpendType" v-model="validForm" lazy-validation>
    <v-row>      
      <v-col>
        <v-text-field 
          label="Concepto" 
          :rules="[rules.required]"
          v-model="name"         
          ></v-text-field>        
      </v-col>
    </v-row>
    
    <v-btn @click="savenewtype" depressed color="#00aff2" dark>Crear</v-btn>    
  </v-form>
</template>
 
<script>

export default {  
  data: () => ({
    validForm: true,
    name: null,
    rules: {
          required: (value) => !!value || 'Required.',         
          lonsm: [ (v) => !v || v.length <= 50 || 'Nombre debe ser menor a 50 caracteres' ],
          lonmd: [ (v) => !v || v.length <= 1 || 'Nombre debe ser menor a 60 caracteres' ],
          lonlg: [ (v) => !v || v.length <= 100 || 'Nombre debe ser menor a 100 caracteres' ],
          lonxl: [ (v) => !v || v.length <= 255 || 'Nombre debe ser menor a 255 caracteres' ],
          lonxxl: [ (v) => !v || v.length <= 1024 || 'Nombre debe ser menor a 1024 caracteres' ],
          },
  }),
  
  methods: {    
    savenewtype() {    
      const data = {        
        name: this.name,
      };
      if (this.$refs.formSpendType.validate()) {
        this.$emit('savenewtype', data);
      }
    },
  }
};
</script>